import React from 'react';
import { Theme, withStyles } from '@material-ui/core/styles';
import { SimpleList } from 'react-design-components';
import { PartnerProductAttribute } from '../../services/PartnerService';

const StyledSimpleList = withStyles((theme: Theme) => ({
  listText: {
    '& span': {
      [theme.breakpoints.down('sm')]: {
        fontSize: 13,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
    },
  },
}))(SimpleList);

interface Props {
  items: Array<PartnerProductAttribute>;
  checked: boolean;
  checkedWidth: number;
  checkedHeight: number;
  color: string;
}

const ServiceList = (props: Props): React.ReactElement<Props> => {
  const { items, checked, checkedWidth, checkedHeight, color } = props;

  return (
    <StyledSimpleList
      items={items.map((attribute: PartnerProductAttribute) => ({ id: attribute.id, title: attribute.description }))}
      checked={checked}
      checkedWidth={checkedWidth}
      checkedHeight={checkedHeight}
      color={color}
    />
  );
};

export default ServiceList as React.ComponentType<Props>;
